import React from "react";
import { createComponent } from "@lit/react";
import { BeamCumulativeImpact as _BeamCumulativeImpact } from "./index";

export const BeamCumulativeImpact = createComponent({
  tagName: _BeamCumulativeImpact.tagName,
  elementClass: _BeamCumulativeImpact,
  react: React,
  events: {},
});

export default BeamCumulativeImpact; // default alias for use with async import utils like next/dynamic and react.lazy
